import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useThemeClasses } from '../../hooks/useThemeClasses';

export default function QASection({
  threads = [],
  onAsk,
  isAuthenticated,
  onLoginRequired,
}) {
  const [question, setQuestion] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { isDark, sc } = useThemeClasses();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const q = question.trim();
    if (q.length < 5) {
      toast.warning('Please enter at least 5 characters.');
      return;
    }
    if (!isAuthenticated) {
      onLoginRequired?.();
      return;
    }
    setSubmitting(true);
    try {
      await onAsk(q);
      setQuestion('');
      toast.success('Question submitted!');
    } catch (err) {
      toast.error(err.message || 'Failed to submit question.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className={sc('pdpPanel')}>
      <h3 className={sc('pdpPanelTitle')}>Questions &amp; Answers</h3>
      {threads.length === 0 ? (
        <p className={`mb-4 text-sm ${isDark ? 'text-slate-500' : 'text-slate-500'}`}>
          No questions yet. Be the first to ask!
        </p>
      ) : (
        <ul className="mb-6 space-y-3">
          {threads.map((t) => (
            <li key={t.id} className={sc('pdpThreadItem')}>
              <p className={`text-sm font-medium ${isDark ? 'text-slate-200' : 'text-slate-800'}`}>
                Q: {t.question}
              </p>
              {t.answer ? (
                <p className={`mt-2 text-sm ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>
                  A: {t.answer}
                </p>
              ) : (
                <p className={`mt-2 text-xs italic ${isDark ? 'text-slate-500' : 'text-slate-400'}`}>
                  Awaiting answer…
                </p>
              )}
            </li>
          ))}
        </ul>
      )}
      <form onSubmit={handleSubmit} className="flex flex-col gap-2 sm:flex-row">
        <input
          type="text"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          placeholder="Ask a question about this part…"
          className={sc('pdpInput')}
          maxLength={500}
        />
        <button
          type="submit"
          disabled={submitting}
          className="rounded-xl bg-blue-600 px-5 py-2.5 text-sm font-bold text-white hover:bg-blue-500 disabled:opacity-50"
        >
          {submitting ? 'Sending…' : 'Ask'}
        </button>
      </form>
    </section>
  );
}
